import axios from "axios";
import { getToken, removeToken, removeUserData } from "./authApi";
import { useErrorHandlingStore } from "../hooks/useErrorHandling";


export const baseUrl = process.env.REACT_APP_API_URL;


export type Guid = string;
export type BaseResponse = { ok: string }
export type BaseResponseWithData<T> = { ok: string, data: T }
export type BaseCreateResponse = { ok: string, id: Guid }
export type BaseInfo = {id: Guid, name: string}
export type BaseInfoList  = ListRespone<BaseInfo>
export type ListRespone<T> = { items: T[] }
export type ListResponeWithHash<T> = { items: T[], hash: number }
export type PaginationListRespone<T> = { items: T[], totalPages: number }
export type EmptyRequest = {};
export type ArrayIdsForDelete = {ids:Guid[]}

type GetRequestParams = {url : string};
type SuccessResponse<T> = {type : "succes", data : T};
type UnathorizedResponse = {type: "unathorized" };
type UnhadledErrorResponse = { type: "unhadledError" };
export type ApiResponse<T> = SuccessResponse<T> | UnathorizedResponse | UnhadledErrorResponse;

export class GetParams{
    query : string;

    constructor(){
        this.query = "";
    }

    Add = (key: string, value : string) => {
        this.query += this.query == "" 
        ? `?${key}=${value}` 
        : `&${key}=${value}`
    }

    GetParams = () => {
        return encodeURI(this.query) ;
    }

    AddList = (key: string, values: string[]) => {
        values.forEach(value => this.Add(key, value));
    }
}

export async function getWithAuth<T>(params : GetRequestParams) : Promise<SuccessResponse<T> | UnathorizedResponse | UnhadledErrorResponse> {
    try
    {
        var result = await axios.get<T>(params.url, {headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        } else {
            // useErrorHandlingStore.getState().showModal(error.response.status ,error.response.data.message)
        }
        return  { type : "unhadledError"}
    }
}


export async function getWithAuthAndParams<TResp>(url : string, params: GetParams) : Promise<SuccessResponse<TResp> | UnathorizedResponse | UnhadledErrorResponse> {
    try
    {
        var queryString = params.GetParams();
        var requestUrl = `${url}${queryString}`;
        var result = await axios.get<TResp>(requestUrl, {headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        }
        return  { type : "unhadledError"}
    }
}

export async function postWithAuth<TReq, TResp>(url: string, request : TReq): Promise<ApiResponse<TResp>> {
    try
    {
        var result = await axios.post<TResp>(url, request, {headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        }
        return  { type : "unhadledError"}
    }
}


export async function postWithAuthWitoutParams<TResp>(url: string): Promise<ApiResponse<TResp>> {
    try
    {
        var result = await axios.post<TResp>(url, {}, {headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        }
        return  { type : "unhadledError"}
    }
}

export async function patchWithAuth<TReq, TResp>(url: string, request : TReq): Promise<ApiResponse<TResp>> {
    try
    {
        var result = await axios.patch<TResp>(url, request, {headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        }
        return  { type : "unhadledError"}
    }
}

export async function deleteWithAuth<TResp>(url: string, id : Guid): Promise<ApiResponse<TResp>> {
    try
    {
        var result = await axios.delete<TResp>(`${url}/${id}`, {headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        }
        return  { type : "unhadledError"}
    }
}

export async function deleteWithBodyAndAuth<TReq, TResp>(url: string, request : TReq): Promise<ApiResponse<TResp>> {
    try
    {
        var result = await axios.delete<TResp>(url , {data: request, headers : {'Authorization' : getToken()}});
        return { type:"succes", data: result.data };
    }
    catch(error : any)
    {
        if(error.response.status == 401) {
            unathorizedLogout();
            return { type : "unathorized"}
        }
        return  { type : "unhadledError"}
    }
}

const unathorizedLogout = () => {
    removeToken();
    removeUserData();
    window.location.reload();
}


axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if(error.response.status != 401){
        useErrorHandlingStore.getState().showModal(error.response.status ,error.response.data.message)
    }
    return Promise.reject(error);
});